import React, { useState } from "react";
import mini_logo from "../imgs/mini_logo.png"

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-content">
          <div className="nav-logo"><a href="/" ><img alt="logo" src={mini_logo} className=""></img></a></div>

          <div className={`Titillium  nav-links ${isOpen ? "open" : ""}`}>
            <br></br>
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/games">Our Games</a>
            <a href="/rental">Rental</a>
            <a href="/technician">Technician Services</a>
            <a href="/contact">Contact</a>
          </div>

          <div className="nav-toggle" onClick={toggleMenu}>
            <span className={`menu-icon ${isOpen ? "open" : ""}`}></span>
          </div>
          <div className="nav-logo-right"><img alt="navagation logo" src={mini_logo} className=""></img></div>
        </div>

      </nav >
      <div className={`Titillium sidebar ${isOpen ? "show" : ""}`}>
        <a className={`linkOp linkA ${isOpen ? "show" : "hide"}`} href="/">Home</a>
        <a className={`linkOp linkB ${isOpen ? "show" : "hide"}`} href="/about">About</a>
        <a className={`linkOp linkC ${isOpen ? "show" : "hide"}`} href="/games">Our Games</a>
        <a className={`linkOp linkD ${isOpen ? "show" : "hide"}`} href="/rental">Rental</a>
        <a className={`linkOp linkE ${isOpen ? "show" : "hide"}`} href="/technician">Technician Services</a>
        <a className={`linkOp linkF ${isOpen ? "show" : "hide"}`} href="/contact">Contact</a>
      </div>
    </>
  );
};

export default Navbar;
